import React from "react";
import "./SessionLockModal.css";

const SessionLockModal = ({
  show,
  code,
  error,
  isSubmitting,
  onCodeChange,
  onConfirm,
  onLogout,
}) => {
  if (!show) {
    return null;
  }

  const canSubmit = !isSubmitting && code.trim().length >= 6;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!canSubmit) {
      return;
    }
    onConfirm();
  };

  return (
    <div className="session-lock-backdrop" role="dialog" aria-modal="true" aria-labelledby="session-lock-title">
      <div className="session-lock-card">
        <h2 id="session-lock-title">Session Timed Out</h2>
        <p className="session-lock-copy">
          For privacy, confirm your identity to continue using this application.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            className="form-control"
            value={code}
            onChange={(event) => onCodeChange(event.target.value)}
            placeholder="Enter MFA code"
            aria-label="MFA code"
          />
          {error ? <div className="session-lock-error">{error}</div> : null}
          <button
            type="submit"
            className="btn btn-primary session-lock-button"
            disabled={!canSubmit}
          >
            {isSubmitting ? "Confirming..." : "Confirm Code"}
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary session-lock-button"
            onClick={onLogout}
            disabled={isSubmitting}
          >
            Logout
          </button>
        </form>
      </div>
    </div>
  );
};

export default SessionLockModal;
